import * as React from 'react';

export default class ManageNotifications extends React.Component {
  public render() {
    return (
      <div>
        <div> Manage Letters</div>
      </div>
    );
  }
}
